import { useTranslation } from 'react-i18next';

import Input from 'components/Input';
import { ENUM_TYPE_OPTION } from 'constants/enum';

const DropdownOption = (props) => {
  const { t } = useTranslation();
  const { isPreview, renderOptions } = props;

  return (
    <>
      {isPreview ? (
        <Input
          value={null}
          readOnly
          disabled={true}
          list={[{ text: t('PLACEHOLDER_DROPDOWN'), value: null }]}
          type="dropdown"
          placeholder={t('PLACEHOLDER_DROPDOWN')}
          className="w-full"
          classNameInput="rounded-lg w-full !text-secondary-354 !block line-clamp-1 text-ellipsis break-words"
        />
      ) : (
        renderOptions(ENUM_TYPE_OPTION.DROPDOWN)
      )}
    </>
  );
};

export default DropdownOption;
